import { items } from "~/data/items";
export const hashToItemKey: Record<number, string> = {};
export const itemKeyToHash: Record<string, number> = {};
const hashToPrice: Record<number, number> = {};
export let conv = false;
function hashString(str: string): number {
	let hash = 0;
	for (let i = 0; i < str.length; i++) {
		hash = (hash << 5) - hash + str.charCodeAt(i);
		hash |= 0;
	}
	return hash;
}
export function generateConvlr() {
	if (conv) return;
	for (const [itemKey, item] of Object.entries(items)) {
		if (!("masterItem" in item) && (item.type === "skin" || item.type === "sticker")) {
			const hash = hashString(itemKey);
			if (hashToItemKey[hash]) console.log("Error", itemKey, hashToItemKey[hash]);
			hashToItemKey[hash] = itemKey;
			itemKeyToHash[itemKey] = hash;
			hashToPrice[hash] = item.price;
		}
	}
	conv = true;
}
// window.GetItemShortNamePriceMap = () => {
// 	const mapSize = Object.keys(hashToPrice).length;
// 	const buffer = new ArrayBuffer(4 * 2 * mapSize);
// 	const intArray = new Int32Array(buffer);
// 	Object.entries(hashToPrice).forEach((entry, index) => {
// 		intArray[index * 2] = Number(entry[0]);
// 		intArray[index * 2 + 1] = entry[1] as number;
// 	});
// 	const blob = new Blob([buffer], { type: "application/octet-stream" });
// 	const link = document.createElement("a");
// 	link.href = window.URL.createObjectURL(blob);
// 	link.download = "itemprices.bin";
// 	link.click();
// 	link.remove();
// };
